<template>
  <main>
    <h6 class="text-info">Riesgos Generales</h6>
    <table class="table table-striped table-sm table-bordered font-size-12">
      <tr>
        <th>Rango</th>
        <th>Condiciones perinatales y posnatales</th>
        <th>Respuesta</th>
      </tr>
      <tr v-for="item in riesgos" :key="item.id">
        <td>
          {{ item.edad_inicio }} {{ item.tipo_edad_inicio }} a
          {{ item.edad_final }} {{ item.tipo_edad_final }}
        </td>
        <td>{{ item.condiciones_perinatales_posnatales }}</td>
        <td>
          {{item.respuesta}}
        </td>
      </tr>
    </table>
  </main>
</template>
<script>
import riesgosGeneralesValeService from "../../../../../services/riesgosGeneralesValeService";
import historiaRiesgosGeneralesValeService from "../../../../../services/historiaRiesgosGeneralesValeService";
import {isEmpty} from "lodash";

export default {
  props: ["idHistoria", "finalizada", "idUsuario"],
  data() {
    return {
      respuesta: {},
      riesgos: {},
      tieneRespuestas : false
    };
  },
  methods: {
    async cargarRiesgos() {
      
      const response = await riesgosGeneralesValeService.index();
      const respuestas = await historiaRiesgosGeneralesValeService.showByHc(this.idHistoria);

      if(!isEmpty(respuestas.data)) this.tieneRespuestas = true;
      
      this.riesgos = response.data.map((riesgo) => {
            
            let respuesta = '';

            if(!isEmpty(respuestas.data)){
                
                const tieneRespuesta = respuestas.data.find(x => parseInt(x.id_riesgo) === parseInt(riesgo.id));
                
                if(tieneRespuesta !== undefined){
                    respuesta = tieneRespuesta.respuesta;
                }

            }

            return {
                ...riesgo,
                respuesta: respuesta,
            };
      });
    },
  },
  created() {
    this.cargarRiesgos();
  },
};
</script>
<style scoped>
.font-size-12 {
  font-size: 12px;
}
</style>